import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postAppointment = async ({
  technicianIds,
  appointmentStart,
  serviceSelectionId,
  suburbId,
  isTechnicianConfirmed,
  jobType,
}: JsonDataItem) => {
  const { data } = await baseQuery('hold-appointment', {
    type: 'POST',
    body: {
      technician_list: technicianIds,
      appointment_start: appointmentStart,
      service_selection_id: serviceSelectionId,
      suburb_id: suburbId,
      technician_confirmed: isTechnicianConfirmed,
      service_type: jobType,
    },
  });

  return data;
};
